import {
  Table,
  TableBody,
  TableCell,
  tableCellClasses,
  TableRow,
} from "@mui/material";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";
import { sv } from "date-fns/locale";
import { Fragment } from "react";
import { TECHNICAL } from "../../util/constants";

export default function ShowTransaction(props: { transaction: any, cardTypeId: any}) {
  const { t } = useTranslation();
  const transaction = props.transaction;
  const cardTypeId = props.cardTypeId;

  return (
    <>
      <Fragment>
        <Table
          sx={{
            [`& .${tableCellClasses.root}`]: { borderBottom: "none" },
            display: "flex",
            ml: transaction.status === "UPDATED" ? "2vw" : null        
          }}
          size="small"
          className="firstColumnBold"
        >
          <TableBody>
            <TableRow sx={{ borderBottom: "none" }}>
              <TableCell>{t("searchCard.cardInfo.personId")}</TableCell>
              <TableCell>{transaction.personId}</TableCell>
            </TableRow>
            <TableRow sx={{ borderBottom: "none" }}>
              <TableCell>{t("amount")}</TableCell>
              <TableCell>{transaction.amount + " kr"}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>{cardTypeId.includes(TECHNICAL) ? t("prescriptionDate") : t("visitingDate")}</TableCell>
              <TableCell>
                {transaction.transactionDate.toLocaleDateString("sv")}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>{t("registrationDate")}</TableCell>
              <TableCell>
                {format(
                  new Date(transaction.registrationDateTime),
                  "d MMMM, yyyy H:mm:ss",
                  { locale: sv }
                )}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>{t("registeredByCareProvider")}</TableCell>
              <TableCell>{transaction.registeringCareProviderId}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>{t("carePrincipal")}</TableCell>
              <TableCell>{transaction.carePrincipal.id}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>{t("careProvider")}</TableCell>
              <TableCell>{transaction.careProvider}</TableCell>
            </TableRow>
            <TableRow sx={{ borderBottom: "unset" }}>
              <TableCell>{t("careUnit")}</TableCell>
              <TableCell>{transaction.careUnit}</TableCell>
            </TableRow>
            {transaction.status !== "ACTIVE" ?
            <TableRow sx={{ borderBottom: "unset" }}>
              <TableCell>{t("reason")}</TableCell>
              <TableCell>{transaction.statusReason}</TableCell>
            </TableRow>
            : null}
          </TableBody>
        </Table>
      </Fragment>
    </>
  );
}
